<template>
</template>
  
<script>
  import settings from "./../backend/LocalSettings";
  
  export default {
    name: "base-page",
    components: {  },
    data () {
      return { 
        loadingVisible: false
      }
    },
    methods: {
      post: async function(url, args={}){
        this.loadingVisible      = true;
        var             response = await this.$http.post(url, args );
        this.loadingVisible      = false;
        if( settings.verify_response(response) )
        {
          return response.body;
        } else {
          this.$router.push("/");
        }
      },
    },
    
  };
  </script>
